'use strict';
var is = require('bpmn-js/lib/util/ModelUtil').is;
var entryFactory = require('../../../../factory/EntryFactory'),
    cmdHelper = require('../../../../helper/CmdHelper');

var DELEGATE_TYPES = [
  'class',
  'expression',
  'delegateExpression'
];

var PROPERTIES = {
  class: 'camunda:class',
  expression: 'camunda:expression',
  delegateExpression: 'camunda:delegateExpression'
};

function isDelegate(type) {
  return DELEGATE_TYPES.indexOf(type) !== -1;
}

function getAttribute(type) {
  return PROPERTIES[type];
}
function httpGet(theUrl)
{
    var params = "somevariable=somevalue&anothervariable=anothervalue";
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open( "GET", theUrl+"?"+params, false ); // false for synchronous request
    xmlHttp.send( null );
    return  JSON.parse(xmlHttp.responseText);

}

module.exports = function(element, bpmnFactory, options, translate) {

  var getImplementationType = options.getImplementationType,
      getBusinessObject = options.getBusinessObject;
    //---------------custom-------------------
    
    if (is(element, 'bpmn:SendTask')){
        var optionsDelegateOptions=[];
        console.log('----------------REQUEST DELEGATE---------------------');
       var requestDelegate = httpGet('/work_order_type_creation/retrieveDelegateSendTask');
      //  fetch('/work_order_type_creation/retrieveDelegateSendTask')
      //   .then(response => response.json())
      //   .then(data => console.log(data));
       // console.log(requestDelegate);
        requestDelegate.forEach(item => {
          optionsDelegateOptions.push({ value: item.value, name: item.name });
        });
        //console.log(optionsDelegateOptions);

        var SELECT_OPTIONS = optionsDelegateOptions;
      }else if(is(element, 'bpmn:ServiceTask')){
        // var SELECT_OPTIONS = [
        //   { value: 'javaclass2', name: translate('Java Class 2') },
        //   { value: 'javaclass3', name: translate('Java Class  3') },
        //   { value: 'javaclass4', name: translate('Java Class 4') }
        // ];
        var optionsDelegateOptions=[];
        var requestDelegate = httpGet('/work_order_type_creation/retrieveDelegateServiceTask');
      
        requestDelegate.forEach(item => {
          optionsDelegateOptions.push({ value: item.value, name: item.name });
        });

        var SELECT_OPTIONS = optionsDelegateOptions;
      }
    //---------------custom-------------------
  function getDelegationLabel(type) {
    switch (type) {
    case 'class':
      return translate('Java Class');
    case 'expression':
      return translate('Expression');
    case 'delegateExpression':
      return translate('Delegate Expression');
    default:
      return '';
    }
  }

  
  // var delegateEntry = entryFactory.textBox({
  //     id: 'delegate',
  //   label: translate('Value'),
  //   dataValueLabel: 'delegationLabel',
  //   modelProperty: 'delegate',

  //   get: function(element, node) {
  //     var bo = getBusinessObject(element);
  //     var type = getImplementationType(element);
  //     var attr = getAttribute(type);
  //     var label = getDelegationLabel(type);
  //     return {
  //       delegate: bo.get(attr),
  //       delegationLabel: label
  //     };
  //   },
  
  var delegateEntry = entryFactory.selectBox({
  
    id : 'delegate',
    label: translate('Value'),
    selectOptions: SELECT_OPTIONS,
    modelProperty: 'delegate',

    get: function(element, node) {
      var bo = getBusinessObject(element);
       var type = getImplementationType(element);
       var attr = getAttribute(type);
       var label = getDelegationLabel(type);
      return {
        delegate: bo.get(attr) ||'',
      };
    },
    set: function(element, values, node) {
      var bo = getBusinessObject(element);
      var type = getImplementationType(element);
      var attr = getAttribute(type);
      var prop = {};
      prop[attr] = values.delegate || '';
      return cmdHelper.updateBusinessObject(element, bo, prop);
    },

    validate: function(element, values, node) {
      return isDelegate(getImplementationType(element)) && !values.delegate ? { delegate: 'Must provide a value' } : {};
    },

    hidden: function(element, node) {
      return !isDelegate(getImplementationType(element));
    }

  });

  return [ delegateEntry ];

};
